import React from 'react';
import { Link } from '../../lib/reactRouterWrapper';
import classNames from 'classnames'
import { useQuery } from "@/lib/crud/useQuery";
import { gql } from "@/lib/generated/gql-codegen";
import { defineStyles } from '@/components/hooks/defineStyles';
import { useStyles } from '@/components/hooks/useStyles';

const localGroupsHomeFragmentQuery = gql(`
  query PostsGroupDetails($documentId: String) {
    localgroup(input: { selector: { documentId: $documentId } }) {
      result {
        ...localGroupsHomeFragment
      }
    }
  }
`);

const styles = defineStyles('PostsGroupDetails', (theme: ThemeType) => ({
  title: {
    display: 'inline-block',
    fontSize: 22,
    verticalAlign: '-webkit-baseline-middle',
    lineHeight: '24px',
    color: theme.palette.text.dim,
    marginTop: -10,
    ...theme.typography.smallCaps,
  },
  notRecentDiscussionTitle: {
    fontFamily: theme.typography.body1.fontFamily,
  },
  recentDiscussionTitle: {
    fontSize: 16,
    fontFamily: theme.typography.fontFamily
  },
  root: {
    marginBottom: 12, 
    marginTop: 10
  }
}))

const PostsGroupDetails = ({documentId, post, inRecentDiscussion}: {
  documentId: string,
  post: PostsBase,
  inRecentDiscussion?: boolean,
}) => {
  const classes = useStyles(styles);
  const { data } = useQuery(localGroupsHomeFragmentQuery, {
    variables: { documentId: documentId },
  });
  const document = data?.localgroup?.result;

  if (!document) {
    return null
  }

  let groupName: React.ReactNode;
  if (post.group) {
    groupName = document.deleted ? document.name : <Link to={'/groups/' + post.group._id }>{ document.name }</Link>
  }

  return <div className={inRecentDiscussion ? '' : classes.root}>
    <div className={classNames(classes.title, {
      [classes.recentDiscussionTitle]: inRecentDiscussion,
      [classes.notRecentDiscussionTitle]: !inRecentDiscussion,
    })}>
      {groupName}
    </div>
  </div>
}

export default PostsGroupDetails;


